var _defs, _path, _line, _line2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tick_empty",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .upgradeline {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "upgradeline",
    d: "M20.09,23.05v6.35c0,.45.37.82.83.82h8.2c.46,0,.83-.37.83-.82v-6.34c0-.46.38-.84.85-.84h4.74c.8,0,1.19-.96.61-1.51l-10.55-10.04c-.32-.31-.83-.31-1.15,0l-10.55,10.04c-.57.55-.18,1.51.61,1.51h4.76c.46,0,.83.37.83.82Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "upgradeline",
    x1: 19.81,
    y1: 35.43,
    x2: 30.22,
    y2: 35.43
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "upgradeline",
    x1: 22.94,
    y1: 39.59,
    x2: 27.1,
    y2: 39.59
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "upgradeline",
    x: 5.24,
    y: 5.24,
    width: 39.56,
    height: 39.56,
    rx: 10.41,
    ry: 10.41
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.5f7f226d2161e00aa1212297409ca5a8.svg";
export { ForwardRef as ReactComponent };